import React from "react";
import { Mail, Send, Facebook } from "lucide-react";
import { Logo } from "./Logo";

export function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="bg-[#0f172a] text-slate-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Logo size={40} />
              <span className="font-head font-extrabold text-white leading-none text-lg">
                Morning
                <br />
                Sunday Teer
              </span>
            </div>
            <p className="text-sm leading-relaxed text-slate-400 max-w-md">
              Your trusted source for Morning Sunday Teer Result, Previous Result, Common Number and
              all live updates.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="https://www.facebook.com/share/1DpVXpizqB/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                data-testid="social-facebook"
                className="w-9 h-9 rounded-full bg-blue-600 flex items-center justify-center hover:opacity-80 transition-opacity"
              >
                <Facebook size={16} className="text-white" />
              </a>
              <a
                href="https://t.me/MorningSundayTeer"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Telegram"
                data-testid="social-telegram"
                className="w-9 h-9 rounded-full bg-sky-500 flex items-center justify-center hover:opacity-80 transition-opacity"
              >
                <Send size={16} className="text-white" />
              </a>
            </div>
          </div>

          <div className="md:text-right">
            <h4 className="text-white font-head font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm md:flex md:flex-col md:items-end">
              <li className="flex items-center gap-2">
                <Mail size={16} className="text-[#ff4500]" />
                <a href="mailto:shillongmorningteer4758@gmail.com" className="hover:text-[#ff8a5b] break-all">
                  shillongmorningteer4758@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Send size={16} className="text-[#ff4500]" />
                <a
                  href="https://t.me/MorningSundayTeer"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#ff8a5b]"
                >
                  @MorningSundayTeer
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 py-6 text-center space-y-2">
          <p className="text-xs text-slate-500 leading-relaxed max-w-3xl mx-auto" data-testid="footer-disclaimer">
            <span className="font-semibold text-slate-400">Disclaimer:</span> Morning Sunday Teer is
            an informational platform only. We do not operate, organize, sell tickets for, or
            facilitate any game or lottery. All numbers and content are provided for general
            information and entertainment reference only and do not guarantee any outcome.
          </p>
          <p className="text-xs text-slate-500" data-testid="footer-established">
            Established in 2020 · Serving visitors from 2020 to 2026.
          </p>
          <p className="text-xs text-slate-500">
            © 2020–2026 Morning Sunday Teer. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
